const DATA_RANGE_FORMAT = 'DD-MM-YYYY';

export default DATA_RANGE_FORMAT;
